export default __webpack_public_path__ + "static/media/Hookah.fe4e75fe.png";